// extracted by mini-css-extract-plugin
module.exports = {"customerRequestWrapper":"style_customerRequestWrapper__32OGU"};